import {useApi} from '@composables/useApi';
import {defineStore} from 'pinia';
import {Bill, FailedGetBillError, FailedGetBillsError} from "@store/api/interfaces";
import {useAuthApi} from "@store/api/authApi";
//import * as Sentry from "@sentry/vue";

export const useBillingApi = defineStore('billingApi', () => {
	const authApi = useAuthApi();
	// TODO: возникает ошибка в методе http.get(),
	// сейчас не понятно при каких обстоятельствах,
	// отображается только в sentry.
	// Мы её игнорируем и отображаем только на 4й раз

	let getBillErrorCount = 0;
	const MAX_IGNORED_ERRORS = 3;

	const http = {
		get: async (billId: number): Promise<Bill|null> => {
			try {
				return await useApi<Bill|null>(`/billing/bill/${billId}`, {
					method: "GET",
					headers: authApi.methods.getAuthHeaders()
				});
			} catch (error: any) {
				getBillErrorCount++;

				console.info(
					`Failed get bill (${getBillErrorCount}/${MAX_IGNORED_ERRORS})`,
					error
				);

				if (getBillErrorCount <= MAX_IGNORED_ERRORS) {
					return null;
				}

				throw new FailedGetBillError(error.message);
			}
		},
		getList: async (): Promise<Bill[]> => {
			try {
				return await useApi<Bill[]>('/billing/list', {
					method: "GET",
					headers: authApi.methods.getAuthHeaders()
				});
			} catch (error: any) {
				console.error('Failed get bills', error);
				//Sentry.captureException(error);
				throw new FailedGetBillsError(error.message);
			}
		}
	}

	const methods = {
		resetGetBillErrors() {
			getBillErrorCount = 0;
		}
	};

	return {
		http,
		methods
	};
})
